export const camelCaseToSeparator = (str, separator = '_') => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? separator : "") + $.toLowerCase())
